import type { MappedCustomDataServiceObjectField, MappedServiceObjectData } from 'common/models';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectTableColumn from './ServiceObjectTableColumn';

interface OwnProps {
  serviceObjects: ServiceObjectInCustomer[];
  data: MappedServiceObjectData[];
}

const ServiceObjectTableVertical = (props: OwnProps) => {
  const { serviceObjects, data } = props;

  // Checklist is unsupported field
  const filteredData = data.filter((x) => x.fieldData?.formField.type !== 'CheckList');

  return (
    <table>
      <thead>
        <tr>
          <td />
          {serviceObjects.map((serviceObject) => (
            <td key={serviceObject.id}>{serviceObject.name}</td>
          ))}
        </tr>
      </thead>
      <tbody>
        {filteredData.map((reportData) => (
          <tr key={reportData.fieldData?.id || reportData.properties?.label}>
            <td>{reportData.fieldData?.label || reportData.properties?.label}</td>
            {serviceObjects.map((serviceObject) => {
              const relatedFieldValue = reportData.values?.find(
                (x) => x.serviceObjectId === serviceObject.id
              )?.value;

              return (
                <td key={serviceObject.id}>
                  {reportData.type === 'FormField' ? (
                    <ServiceObjectTableColumn
                      fieldData={reportData.fieldData as MappedCustomDataServiceObjectField}
                      serviceObjectId={serviceObject.id}
                    />
                  ) : (
                    <span>{relatedFieldValue || ''}</span>
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ServiceObjectTableVertical;
